module.exports = __webpack_public_path__ + "static/media/pulsar-logo.4fff8b97.png";